import {
  FulfillmentOrderAddressSchema,
  type IFulfillmentOrderAddress,
} from "@redotech/redo-model/fulfillments/fulfillment-order-address";
import * as z from "zod/v4";

export const updateShippingAddress = {
  name: "updateShippingAddress" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    address: FulfillmentOrderAddressSchema as IFulfillmentOrderAddress,
    updateRedoOnMarketplaceFailure: z.boolean().optional(),
  }),
  output: z.object({
    // This field is for backwards compatibility
    success: z.boolean(),
    redoAddressUpdateSuccess: z.boolean().nullish(),
    salesChannelUpdateSuccess: z.boolean().nullish(),
  }),
};
